<template>
	<div class="xieyi u-flex-col u-col-center">
		<div class="xieyi-box" v-html="content" style="color: #fff"></div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				content:'',
				type: '',
			}
		},
		created() {
			this.type = this.$route.query.type
			this.getdata()
		},
		mounted() {
			this.$parent.settitle(this.$t('隐私协议'))
		},
		methods: {
			getdata(){
				this.$http.post('/api/Index/configInfo').then(res => {
					const regex = new RegExp('<img', 'gi')
					if(this.type == '1') {
						if(this.$locale == 'zh'){
							this.content = res.result.sytk.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}else if(this.$locale == 'en'){
							this.content = res.result.sytkEnglish.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}else{
							this.content = res.result.sytkGerman.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}
					} else {
						if(this.$locale == 'zh'){
							this.content = res.result.ysxy.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}else if(this.$locale == 'en'){
							this.content = res.result.ysxyEnglish.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}else{
							this.content = res.result.ysxyGerman.replace(regex, `<img style="max-width: 100%; height: auto"`)
						}
					}
				})
			}
		}
	}
</script>

<style lang="scss">

</style>